import { createSelector } from '@reduxjs/toolkit';
import sortBy from 'lodash/sortBy';

import { emptyArr } from '@shared/constants';
import {
  isMBCAndLeaderSel,
  isMeritBadgeCounselorSel,
  ranksSel,
  unitTypeIdSel,
} from '@shared/duck/selectors/general.selectors';

import {
  allowedAdvancementsMeritBadgeCounselor,
  moduleName,
  unitsAvailableAdvancements,
} from '../constants';

const moduleSel = state => state[moduleName];

export const unitInfoSel = createSelector(moduleSel, state => state.unitInfo);

export const unitRelatedRanksSel = createSelector(
  ranksSel,
  unitTypeIdSel,
  (ranks, unitTypeId) => {
    const relatedRanks = ranks.filter(
      ({ programId }) => unitTypeId == programId,
    );
    return sortBy(relatedRanks, 'level');
  },
);

export const currentUnitGuidSel = createSelector(
  unitInfoSel,
  state => state.organizationGuid,
);

export const currentUnitOrganizationTypeIdSel = createSelector(
  unitInfoSel,
  state => state.organizationTypeId,
);

const advancementsTypesSel = state =>
  unitsAvailableAdvancements[unitTypeIdSel(state)] || emptyArr;

/**
 * The advancement types the logged in user is allowed to work with in the
 * selected organization, based on the unit program and on the roles the user
 * holds there.
 *
 * Callers use it to decide which advancements to request and to display: the
 * youth profile skips the fetch for any type missing from this list, and the
 * record advancement flow only offers the types it contains.
 */
export const eligibleAdvancementTypesSel = createSelector(
  advancementsTypesSel,
  isMeritBadgeCounselorSel,
  isMBCAndLeaderSel,
  (eligibileAdvancements, isMeritBadgeCounselor, isMBCAndLeader) => {
    // A counselor is restricted to merit badges even when the organization is a
    // unit with a program of its own. Leader roles held on top of the counselor
    // one keep the advancements of the unit program.
    if (isMeritBadgeCounselor && !isMBCAndLeader) {
      return allowedAdvancementsMeritBadgeCounselor;
    }
    return eligibileAdvancements;
  },
);

export const unitInfoLoadingSel = state => moduleSel(state).unitInfoLoading;
export const unitInfoErrorSel = state => moduleSel(state).unitInfoError;
